import { Headline } from 'components/Headline';

import { StatusItemType } from '../ConnectionStatus';
import * as S from './StatusItem.styles';

export type StatusItemProps = Omit<StatusItemType, 'id'>;

export function StatusItem(props: StatusItemProps): React.ReactElement {
  const { label, status } = { ...props };

  return (
    <S.Container>
      {label && <Headline fontWeight="normal">{label}</Headline>}

      <S.Label data-testid="status">{status ? 'OK' : 'NO'}</S.Label>
    </S.Container>
  );
}
